import { r as e } from "./chunk-foFoljWS.js";
var t = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "localconfigv2.schema.json",
	title: "Capture Edge Local Config V2",
	description: "Schema for the local configuration of Capture Edge V2",
	type: "object",
	properties: {
		_id: { $ref: "_id.schema.json" },
		localDatabaseConfig: { $ref: "localdatabaseconfig.schema.json" },
		collectorSettings: { $ref: "collectorsettings.schema.json" },
		syncSettings: { $ref: "syncsettings.schema.json" },
		analyticsSettings: { $ref: "analyticssettings.schema.json" },
		cloudManagerSettings: { $ref: "cloudmanagersettings.schema.json" },
		edgeCloudBusSettings: { $ref: "edgecloudbussettings.schema.json" },
		id: {
			type: "integer",
			minimum: 0
		},
		name: {
			type: "string",
			minLength: 3,
			pattern: "^[ a-zA-Z0-9_-]+$"
		},
		gatewayName: { type: ["string", "null"] },
		gatewayIdentifier: { type: ["string", "null"] },
		company: { $ref: "company.schema.json" },
		configTags: {
			type: ["array", "null"],
			items: { $ref: "loggertag.schema.json" }
		},
		edgeBusSettings: { $ref: "edgebussettings.schema.json" }
	},
	required: [
		"localDatabaseConfig",
		"collectorSettings",
		"syncSettings",
		"analyticsSettings",
		"cloudManagerSettings",
		"id",
		"name",
		"company",
		"edgeBusSettings"
	],
	additionalProperties: !0
}, n = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "_id.schema.json",
	title: "Capture Edge Local Config V2 - ObjectID",
	description: "Schema for private ObjectID",
	type: ["object", "null"],
	properties: {
		timestamp: {
			type: "integer",
			minimum: 0
		},
		machine: {
			type: "integer",
			minimum: 0
		},
		pid: {
			type: "integer",
			minimum: 0
		},
		increment: {
			type: "integer",
			minimum: 0
		},
		creationTime: {
			type: "string",
			format: "date-time"
		}
	},
	required: [
		"timestamp",
		"machine",
		"pid",
		"increment",
		"creationTime"
	]
}, r = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "localdatabaseconfig.schema.json",
	title: "Capture Edge Local Config V2 - Local Database Configuration",
	description: "Schema for the local database configuration array V2",
	type: "array",
	items: {
		type: "object",
		properties: {
			dbId: {
				type: "string",
				minLength: 1,
				default: "0"
			},
			type: { oneOf: [{
				type: "integer",
				minimum: 0,
				maximum: 7,
				default: 0
			}, {
				type: "string",
				enum: [
					"Influx",
					"Csv",
					"Mqtt",
					"Redis",
					"Influx2",
					"NatsJetStream",
					"TimescaleWide",
					"TimescaleNarrow"
				]
			}] },
			address: {
				type: "string",
				minLength: 1,
				default: "http://localhost"
			},
			port: {
				type: "integer",
				minimum: 0,
				maximum: 65535,
				default: 8086
			},
			username: {
				type: "string",
				default: "root"
			},
			password: {
				type: "string",
				default: "root"
			},
			externalDb: {
				type: "boolean",
				default: !1
			},
			custom: {
				type: "string",
				isJsonString: !0,
				errorMessage: "Must be a valid JSON object string.",
				default: ""
			},
			buckets: {
				type: "array",
				items: {
					type: "object",
					properties: {
						id: {
							type: "string",
							minLength: 1,
							default: "01A"
						},
						dbName: {
							type: "string",
							minLength: 4,
							default: "Capture"
						},
						retentionName: {
							type: "string",
							pattern: "^[a-zA-Z]*$|\\$(.*)",
							default: "oneWeek"
						},
						duration: {
							type: "string",
							default: "7d"
						},
						important: {
							type: "boolean",
							default: !1
						},
						custom: {
							type: "string",
							isJsonString: !0,
							errorMessage: "Must be a valid JSON object string.",
							default: ""
						}
					},
					required: [
						"id",
						"dbName",
						"retentionName",
						"duration",
						"important"
					]
				}
			},
			name: {
				type: "string",
				minLength: 1,
				default: "Capture"
			},
			identifierOption: { oneOf: [{
				type: "string",
				enum: ["SourcePath", "VariableName"]
			}, {
				type: "integer",
				enum: [0, 1]
			}] }
		},
		required: [
			"dbId",
			"type",
			"externalDb",
			"buckets",
			"name"
		]
	},
	allOf: [
		{
			$comment: "Influx (0)",
			if: { properties: { type: { oneOf: [{ const: 0 }, { const: "Influx" }] } } },
			then: {
				required: ["address", "port"],
				properties: {
					address: {
						type: "string",
						pattern: "^(http|https)://.*|\\$(.*)"
					},
					buckets: {
						type: "array",
						items: {
							type: "object",
							properties: {
								retentionName: {
									type: "string",
									minLength: 4
								},
								duration: {
									type: "string",
									pattern: "^[0-9]*[hd]$|\\$(.*)"
								},
								dbName: {
									type: "string",
									pattern: "^[a-zA-Z][A-Za-z0-9]*$|\\$(.*)"
								}
							}
						}
					}
				}
			}
		},
		{
			$comment: "Csv (1)",
			if: { properties: { type: { oneOf: [{ const: 1 }, { const: "Csv" }] } } },
			then: {
				required: ["address"],
				properties: { buckets: {
					type: "array",
					items: {
						type: "object",
						properties: {
							retentionName: {
								type: "string",
								minLength: 4
							},
							duration: {
								type: "string",
								pattern: "^[0-9]*[hd]$|\\$(.*)"
							},
							dbName: {
								type: "string",
								pattern: "^[a-zA-Z][A-Za-z0-9]*$|\\$(.*)"
							}
						}
					}
				} }
			}
		},
		{
			$comment: "Mqtt (2)",
			if: { properties: { type: { oneOf: [{ const: 2 }, { const: "Mqtt" }] } } },
			then: {
				required: [
					"address",
					"port",
					"username",
					"password"
				],
				properties: { buckets: {
					type: "array",
					items: {
						type: "object",
						properties: { dbName: {
							type: "string",
							pattern: "^[a-zA-Z][A-Za-z0-9][A-Za-z0-9\\/]*$|\\$(.*)"
						} }
					}
				} }
			}
		},
		{
			$comment: "Redis (3)",
			if: { properties: { type: { oneOf: [{ const: 3 }, { const: "Redis" }] } } },
			then: {
				required: [
					"address",
					"port",
					"username",
					"password"
				],
				properties: { buckets: {
					type: "array",
					items: {
						type: "object",
						properties: { duration: {
							type: "string",
							pattern: "^[0-9]*[mhd]$|\\$(.*)"
						} }
					}
				} }
			}
		},
		{
			$comment: "Influx2 (4)",
			if: { properties: { type: { oneOf: [{ const: 4 }, { const: "Influx2" }] } } },
			then: { required: [
				"address",
				"port",
				"password",
				"custom"
			] }
		},
		{
			$comment: "NatsJetStream (5) and TimescaleWide (6)",
			if: { properties: { type: { oneOf: [
				{ const: 5 },
				{ const: 6 },
				{ const: "NatsJetStream" },
				{ const: "TimescaleWide" }
			] } } },
			then: { required: [
				"address",
				"port",
				"username",
				"password"
			] }
		},
		{
			$comment: "TimescaleNarrow (7)",
			if: { properties: { type: { oneOf: [{ const: 7 }, { const: "TimescaleNarrow" }] } } },
			then: { required: [
				"address",
				"port",
				"username",
				"password",
				"identifierOption"
			] }
		}
	]
}, i = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "syncsettings.schema.json",
	title: "Capture Edge Local Config V2 - Sync Settings",
	description: "Schema for the Syncer Settings of Capture Edge V2",
	type: "object",
	properties: {
		syncDelay: {
			type: "integer",
			default: 30
		},
		workers: {
			type: "integer",
			default: 1
		},
		enabled: {
			type: "boolean",
			default: !0
		},
		debugMode: {
			type: "boolean",
			default: !1
		},
		custom: {
			type: "string",
			isJsonString: !0,
			errorMessage: "Must be a valid JSON object string.",
			default: ""
		},
		syncDestinations: {
			type: "array",
			items: {
				type: "object",
				properties: {
					destinationId: {
						type: "integer",
						default: 0
					},
					type: { oneOf: [{
						type: "integer",
						minimum: 0,
						maximum: 0,
						default: 0
					}, {
						type: "string",
						enum: ["CaptureRestApi"],
						default: "CaptureRestApi"
					}] },
					syncServer: {
						type: "string",
						minLength: 1,
						pattern: "^(http|https)://(.*)"
					},
					authServer: {
						type: "string",
						minLength: 0,
						pattern: "^(http|https)://(.*)|^$",
						default: ""
					},
					username: {
						type: "string",
						default: ""
					},
					password: {
						type: "string",
						default: ""
					},
					custom: {
						type: "string",
						isJsonString: !0,
						errorMessage: "Must be a valid JSON object string.",
						default: ""
					},
					pointsPerRequest: {
						type: "integer",
						default: 1e4
					},
					fieldsPointsRatio: {
						type: "integer",
						default: 0
					},
					minPointsToSync: {
						type: "integer",
						default: 100
					},
					minPointsMeasurementSwitch: {
						type: "integer",
						default: 1e4
					},
					retentionMeasurementSyncInfo: {
						type: "array",
						items: {
							type: "object",
							properties: {
								dbId: {
									type: "string",
									minLength: 1,
									default: "0"
								},
								bucketId: {
									type: "string",
									minLength: 1,
									default: "01A"
								},
								extraSync: {
									type: "boolean",
									default: !0
								},
								measurementList: {
									type: "array",
									items: {
										type: "string",
										minLength: 1
									},
									default: ["Monitoring"]
								}
							},
							required: [
								"dbId",
								"bucketId",
								"extraSync",
								"measurementList"
							]
						},
						default: []
					},
					syncRules: {
						type: ["array", "null"],
						items: {
							type: "object",
							properties: {
								dbId: { type: "integer" },
								bucketId: { type: "string" },
								adapter: { type: "string" },
								fallbackAfter: { type: "string" },
								fallbackDuration: { type: "string" }
							}
						},
						default: []
					},
					deleteFilesAfterSyncing: {
						type: "boolean",
						default: !1
					}
				},
				required: [
					"destinationId",
					"type",
					"syncServer",
					"authServer",
					"username",
					"password",
					"pointsPerRequest",
					"fieldsPointsRatio",
					"minPointsToSync",
					"minPointsMeasurementSwitch",
					"retentionMeasurementSyncInfo",
					"deleteFilesAfterSyncing"
				]
			},
			default: []
		},
		enhancePointsWithSyncTime: {
			type: "boolean",
			default: !1
		}
	},
	required: [
		"syncDelay",
		"workers",
		"enabled",
		"syncDestinations",
		"enhancePointsWithSyncTime"
	]
}, a = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "analyticssettings.schema.json",
	title: "Capture Edge Local Config V2 - Analytics Settings",
	description: "Schema for the analytics settings of Capture Edge V2",
	type: "object",
	properties: {
		enabled: {
			type: "boolean",
			default: !0
		},
		srcBucketId: {
			type: "string",
			minLength: 0,
			default: "01A"
		},
		dstBucketId: {
			type: "string",
			minLength: 0,
			default: "01B"
		},
		timeFrameBefore: {
			type: "integer",
			default: 2e4
		},
		timeFrameAfter: {
			type: "integer",
			default: 2e4
		},
		triggers: {
			type: "array",
			items: {
				type: "object",
				properties: {
					type: {
						type: "integer",
						minimum: 0
					},
					measurement: {
						type: "string",
						minLength: 1
					},
					field: {
						type: "string",
						minLength: 1
					},
					method: {
						type: "string",
						minLength: 1
					},
					threshold: {
						type: "array",
						items: { type: [
							"number",
							"string",
							"boolean",
							"object"
						] }
					},
					active: {
						type: ["object", "null"],
						properties: {},
						additionalProperties: !0
					},
					idTag: {
						description: "start type 2",
						type: "string"
					},
					alias: { type: "string" },
					eventType: { type: "string" },
					isArray: { type: "boolean" },
					value: {
						type: ["object", "null"],
						properties: {},
						additionalProperties: !0
					},
					lastTags: {
						type: ["null", "object"],
						properties: {},
						additionalProperties: !0
					},
					lastChangeTime: { type: "integer" }
				},
				required: [
					"type",
					"measurement",
					"field",
					"method"
				]
			},
			default: []
		},
		isBlacklist: {
			type: "boolean",
			default: !1
		},
		measurements: {
			type: "array",
			items: {
				type: "string",
				minLength: 1
			},
			default: []
		},
		detailName: {
			type: "string",
			minLength: 1,
			default: "Alarm_"
		},
		lastNotNull: {
			type: "boolean",
			default: !1
		}
	},
	allOf: [{
		if: { properties: { triggers: { minItems: 1 } } },
		then: { properties: {
			srcBucketId: { minLength: 1 },
			dstBucketId: { minLength: 1 }
		} }
	}, {
		if: { properties: { enabled: { const: !1 } } },
		then: { required: ["enabled"] },
		else: { required: [
			"enabled",
			"srcBucketId",
			"dstBucketId",
			"timeFrameBefore",
			"timeFrameAfter",
			"triggers",
			"isBlacklist",
			"measurements",
			"detailName",
			"lastNotNull"
		] }
	}]
}, o = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "cloudmanagersettings.schema.json",
	title: "Capture Edge Local Config V2 - CloudManager Settings",
	description: "Schema for the cloud manager of Capture Edge V2",
	type: "object",
	properties: {
		updaterEndpoint: {
			type: "string",
			pattern: "^(http|https)://(.*)",
			default: "https://capture-vintecc.com/Updater"
		},
		provisioningEndpoint: {
			type: "string",
			pattern: "^(http|https)://(.*)",
			default: "https://capture-vintecc.com/Provisioning"
		},
		authEndpoint: {
			type: "string",
			pattern: "^(http|https)://(.*)",
			default: "https://capture-vintecc.com/auth"
		},
		company: {
			type: "string",
			deprecated: !0,
			default: ""
		},
		cloudIdTag: {
			type: "string",
			default: ""
		},
		configRefresh: {
			type: "integer",
			default: 1e4
		},
		varTypes: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "integer",
						minimum: 0
					},
					name: {
						type: "string",
						minLength: 1
					},
					plcTypeId: {
						type: "integer",
						minimum: 0
					}
				},
				required: [
					"id",
					"name",
					"plcTypeId"
				]
			},
			default: []
		},
		collectTypes: {
			type: "array",
			items: {
				type: "object",
				title: "The first anyOf schema",
				description: "An explanation about the purpose of this instance.",
				default: {},
				examples: [{
					id: 1,
					name: "On change"
				}],
				properties: {
					id: {
						type: "integer",
						minimum: 0
					},
					name: {
						type: "string",
						minLength: 1
					}
				},
				required: ["id", "name"]
			},
			default: []
		},
		dwnSampleMethods: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "integer",
						minimum: 0
					},
					name: {
						type: "string",
						minLength: 1
					}
				},
				required: ["id", "name"]
			},
			default: []
		},
		cpuTypes: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "integer",
						minimum: 0
					},
					name: {
						type: "string",
						minLength: 1
					}
				},
				required: ["id", "name"]
			},
			default: []
		},
		plcTypes: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: {
						type: "integer",
						minimum: 0
					},
					name: {
						type: "string",
						minLength: 1
					}
				},
				required: ["id", "name"]
			},
			default: []
		},
		mirrorTypes: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: { oneOf: [{
						type: "integer",
						minimum: 0,
						maximum: 3
					}, {
						type: "string",
						enum: [
							"Undefined",
							"OpcUa",
							"Mqtt",
							"Redis"
						]
					}] },
					name: {
						type: "string",
						minLength: 1
					}
				},
				required: ["id", "name"]
			},
			default: []
		}
	},
	required: [
		"updaterEndpoint",
		"provisioningEndpoint",
		"authEndpoint",
		"cloudIdTag",
		"configRefresh",
		"varTypes",
		"collectTypes",
		"dwnSampleMethods",
		"cpuTypes",
		"plcTypes",
		"mirrorTypes"
	],
	additionalProperties: !0
}, s = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "company.schema.json",
	title: "Capture Edge Local Config V2 - Company",
	description: "Schema for the Company of Capture Edge V2",
	type: "object",
	properties: {
		id: {
			type: "integer",
			minimum: 0
		},
		name: {
			type: "string",
			minLength: 1
		}
	},
	required: ["id", "name"]
}, c = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "edgecloudbussettings.schema.json",
	title: "Capture Edge Local Config V2 - Edge Cloud Bus Settings",
	description: "Schema for the edge cloud bus settings of Capture Edge V2",
	type: ["object", "null"],
	properties: {
		enableMqtt: {
			type: "boolean",
			default: !0
		},
		mqttEndpoint: {
			type: "string",
			minLength: 0,
			default: "broker.capture-vintecc.com"
		}
	},
	required: ["enableMqtt"],
	allOf: [{
		if: { properties: { enableMqtt: !0 } },
		then: { properties: { mqttEndpoint: { minLength: 1 } } }
	}]
}, l = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "loggertag.schema.json",
	title: "Capture Edge Local Config V2 - Logger Tag",
	description: "Schema for the Logger Tag of Capture Edge V2",
	type: "object",
	properties: {
		key: { type: "string" },
		global: { type: "boolean" },
		values: {
			type: "array",
			items: { type: "string" }
		}
	},
	required: [
		"key",
		"global",
		"values"
	]
}, u = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "edgebussettings.schema.json",
	title: "Capture Edge Local Config V2 - Edge Bus Settings",
	description: "Schema for the edge bus settings of Capture Edge V2",
	type: ["object", "null"],
	properties: {
		edgeBusConnections: {
			type: "array",
			items: {
				type: "object",
				properties: {
					isEnabled: { type: "boolean" },
					id: { type: "string" },
					type: { oneOf: [{
						type: "integer",
						minimum: 0,
						maximum: 2
					}, {
						type: "string",
						enum: [
							"Undefined",
							"Mqtt",
							"Redis"
						]
					}] },
					address: { type: "string" },
					port: { type: "integer" },
					username: { type: "string" },
					password: { type: "string" },
					passwordEncryptionMode: { oneOf: [{
						type: "integer",
						minimum: 0,
						maximum: 1
					}, {
						type: "string",
						enum: ["PlainText", "Encrypted"]
					}] },
					useTls: { type: "boolean" },
					allowUntrustedCertificates: { type: "boolean" },
					databaseId: { type: ["integer", "null"] },
					useRedisJson: { type: "boolean" }
				}
			}
		},
		maximumMessageSize: { type: "integer" }
	}
}, d = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "collectorsettings.schema.json",
	title: "Capture Edge Local Config V2 - CollectorSettings",
	description: "Schema for the collector settings V2",
	type: "object",
	properties: {
		global: { $ref: "global.schema.json" },
		realTimeSyncDestinations: { $ref: "realtime-syncdestinations.schema.json" },
		connections: {
			type: "array",
			items: { $ref: "connections.schema.json" },
			default: []
		},
		writeToDbDelayMs: {
			type: "integer",
			minimum: 0,
			default: 0
		}
	},
	required: [
		"global",
		"connections",
		"writeToDbDelayMs"
	]
}, f = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "global.schema.json",
	title: "Capture Edge Local Config V2 - Collector - Global",
	description: "Schema for the Global collector settings of V2",
	type: "object",
	properties: {
		minStorageAvailable: {
			type: "integer",
			minimum: 0,
			default: 100
		},
		maxBufferPoints: {
			type: "integer",
			minimum: 0,
			default: 1e4
		},
		writeTimeout: {
			type: "integer",
			minimum: 0,
			default: 5e3
		},
		debugMode: {
			type: "boolean",
			default: !1
		},
		fileLog: {
			type: "boolean",
			default: !1
		},
		mirrorMode: {
			type: "boolean",
			default: !1
		},
		enabled: {
			type: "boolean",
			default: !0
		},
		timeOffsetInterval: {
			type: "integer",
			minimum: 0,
			default: 0
		},
		enableMqtt: {
			type: "boolean",
			default: !0,
			deprecated: !0
		},
		mqttEndpoint: {
			type: "string",
			minLength: 1,
			default: "mqtt.capture-vintecc.com",
			deprecated: !0
		},
		mirrors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					identifier: {
						type: "string",
						format: "uuid"
					},
					name: { type: "string" },
					settings: { $ref: "#/$defs/mirrorsettings" }
				}
			},
			default: []
		},
		mirrorsettings: {
			$ref: "#/$defs/mirrorsettings",
			default: null,
			deprecated: !0
		},
		adsRouterSettings: {
			type: "object",
			properties: {
				enabled: {
					type: "boolean",
					default: !1
				},
				localAmsNetId: {
					type: "string",
					pattern: "^(([0-9]{0,3}?).){5}([0-9]{1,3})$|\\$(.*)",
					errorMessage: { pattern: "Must be either a valid 6-part dotted number or start with $ followed by text." },
					default: "1.1.1.1.1.1"
				},
				routes: {
					type: "array",
					items: {
						type: "object",
						properties: {
							name: {
								type: "string",
								minLength: 1
							},
							amsNetId: {
								type: "string",
								minLength: 1
							},
							ipAddress: {
								type: "string",
								minLength: 1
							}
						},
						required: [
							"name",
							"amsNetId",
							"ipAddress"
						]
					},
					default: []
				}
			},
			required: [
				"enabled",
				"localAmsNetId",
				"routes"
			]
		}
	},
	required: [
		"minStorageAvailable",
		"maxBufferPoints",
		"writeTimeout",
		"debugMode",
		"fileLog",
		"mirrorMode",
		"enabled",
		"timeOffsetInterval",
		"enableMqtt",
		"mqttEndpoint",
		"adsRouterSettings"
	],
	$defs: { mirrorsettings: {
		type: ["object", "null"],
		properties: {
			type: { oneOf: [{
				type: "integer",
				minimum: 0,
				maximum: 3,
				default: 0
			}, {
				type: "string",
				enum: [
					"Undefined",
					"OpcUa",
					"Mqtt",
					"Redis"
				],
				default: "Undefined"
			}] },
			port: {
				type: "integer",
				minimum: 0,
				maximum: 65535,
				default: 4840
			},
			endpoint: {
				type: "string",
				minLength: 1,
				default: "0.0.0.0"
			},
			username: {
				type: "string",
				default: "Capture"
			},
			password: {
				type: "string",
				default: ""
			},
			passwordEncryptionMode: { oneOf: [{
				type: "integer",
				minimum: 0,
				maximum: 1,
				default: 0
			}, {
				type: "string",
				enum: ["PlainText", "Encrypted"],
				default: "PlainText"
			}] },
			model: {
				type: "string",
				default: ""
			},
			custom: {
				type: "string",
				isJsonString: !0,
				errorMessage: "Must be a valid JSON object string.",
				default: ""
			},
			securityPolicies: {
				type: "array",
				items: { type: "string" },
				default: []
			},
			clientCertificates: {
				type: "array",
				items: {
					type: "object",
					properties: {
						description: {
							type: "string",
							minLength: 1
						},
						certificateBase64: {
							type: "string",
							minLength: 1
						},
						password: {
							type: "string",
							minLength: 1
						}
					},
					required: [
						"description",
						"certificateBase64",
						"password"
					]
				},
				default: []
			},
			retain: {
				type: "boolean",
				default: !1
			},
			qualityOfServiceLevel: { oneOf: [{
				type: "integer",
				minimum: 0,
				maximum: 2
			}, {
				type: "string",
				enum: [
					"AtMostOnce",
					"AtLeastOnce",
					"ExactlyOnce"
				],
				default: "AtMostOnce"
			}] },
			rootTopics: {
				type: "array",
				items: { type: "string" }
			}
		},
		required: [
			"type",
			"port",
			"endpoint",
			"username",
			"password",
			"model",
			"securityPolicies"
		],
		if: { properties: { type: { oneOf: [{ const: "Mqtt" }, { const: 2 }] } } },
		then: { required: [
			"retain",
			"qualityOfServiceLevel",
			"rootTopics"
		] }
	} }
}, p = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "realtime-syncdestinations.schema.json",
	title: "Capture Edge Local Config V2 - Collector - Real Time Sync Destinations",
	description: "Schema for the real time sync destinations of the Collector in Capture Edge V2",
	type: ["array", "null"],
	items: {
		type: "object",
		properties: {
			type: { oneOf: [{
				type: "string",
				enum: ["Mqtt"]
			}, {
				type: "integer",
				minimum: 0,
				maximum: 0
			}] },
			id: {
				type: "string",
				format: "uuid"
			},
			enabled: { type: "boolean" },
			name: { type: "string" },
			endpoint: { type: "string" },
			username: { type: "string" },
			password: { type: "string" },
			useCaptureCredentials: { type: "boolean" },
			skipLocalDatabase: { type: "boolean" },
			syncEverything: { type: "boolean" },
			measurementsToSync: {
				type: "array",
				items: { type: "string" }
			},
			variablesToSync: {
				type: "array",
				items: { type: "string" }
			},
			queueCapacity: { type: "integer" },
			maxSendThreads: { type: "integer" }
		},
		required: [
			"type",
			"id",
			"enabled",
			"name",
			"endpoint",
			"useCaptureCredentials",
			"skipLocalDatabase",
			"syncEverything",
			"queueCapacity",
			"maxSendThreads"
		]
	}
}, m = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "connections-tags.schema.json",
	title: "Capture Edge Local Config V2 - Collector - Connections - Tags",
	description: "Schema for the tags of connections in Capture Edge V2",
	type: "object",
	properties: {
		name: {
			type: "string",
			minLength: 1
		},
		defaultValue: { type: "string" },
		readFromPlc: { type: "boolean" },
		mapping: { type: ["string", "null"] },
		global: { type: "boolean" },
		isCompanyTag: { type: "boolean" },
		cloudWrite: { type: "boolean" },
		cloudRead: { type: "boolean" },
		enabled: { type: "boolean" },
		custom: {
			type: "string",
			isJsonString: !0,
			errorMessage: "Must be a valid JSON object string."
		},
		mirrorConfigurations: {},
		mirror: {
			type: "boolean",
			deprecated: !0
		},
		mirrorType: {
			type: "integer",
			deprecated: !0
		},
		mirrorHistorize: {
			type: "boolean",
			deprecated: !0
		},
		mirrorHistorizeCount: {
			type: "integer",
			deprecated: !0
		},
		mirrorWrite: {
			type: "boolean",
			deprecated: !0
		}
	},
	$comment: "define mirror props already so they are not unknown properties when imported.",
	required: [
		"name",
		"defaultValue",
		"readFromPlc",
		"mapping",
		"global",
		"isCompanyTag",
		"cloudWrite",
		"cloudRead",
		"enabled"
	],
	allOf: [{ $ref: "mirror-configurations.schema.json#/$defs/mirrorproperties" }, {
		if: { properties: { readFromPlc: { const: !0 } } },
		then: {
			properties: { mapping: {
				type: "string",
				minLength: 1
			} },
			required: ["mapping"]
		},
		else: { properties: { mapping: { type: ["string", "null"] } } }
	}]
}, h = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "mirror-configurations.schema.json",
	title: "Capture Edge Local Config V2 - Collector - Global - MirrorConfiguration",
	description: "Schema for validating either new or deprecated mirror configurations.",
	$defs: { mirrorproperties: { anyOf: [{
		properties: { mirrorConfigurations: {
			type: "object",
			patternProperties: { "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$": {
				type: "object",
				properties: {
					readable: {
						type: "boolean",
						default: !1
					},
					writable: {
						type: "boolean",
						default: !1
					},
					mapping: {
						type: ["string", "null"],
						default: ""
					}
				},
				required: [
					"readable",
					"writable",
					"mapping"
				],
				additionalProperties: !0
			} }
		} },
		required: ["mirrorConfigurations"]
	}, {
		properties: {
			mirror: {
				type: "boolean",
				deprecated: !0
			},
			mirrorType: {
				type: "integer",
				deprecated: !0
			},
			mirrorHistorize: {
				type: "boolean",
				deprecated: !0
			},
			mirrorHistorizeCount: {
				type: "integer",
				minimum: 0,
				maximum: 1e3,
				deprecated: !0
			},
			mirrorWrite: {
				type: "boolean",
				deprecated: !0
			},
			mirrorBinding: {
				type: "string",
				deprecated: !0
			}
		},
		required: [
			"mirror",
			"mirrorType",
			"mirrorHistorize",
			"mirrorHistorizeCount",
			"mirrorWrite"
		]
	}] } }
}, g = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "connections-conditiontriggers.schema.json",
	title: "Capture Edge Local Config V2 - Collector - Connections - Condition Triggers",
	description: "Schema for the condition triggers of connections in Capture Edge V2",
	type: "object",
	properties: {
		name: {
			type: "string",
			minLength: 1
		},
		condition: { type: "integer" },
		values: {
			type: "array",
			items: { type: "integer" },
			minItems: 1
		},
		timeout: { type: "integer" },
		mapping: { type: "string" },
		cloudWrite: { type: "boolean" },
		cloudRead: { type: "boolean" },
		enabled: { type: "boolean" },
		custom: {
			type: "string",
			isJsonString: !0,
			errorMessage: "Must be a valid JSON object string."
		},
		mirrorConfigurations: {},
		mirror: {
			type: "boolean",
			deprecated: !0
		},
		mirrorType: {
			type: "integer",
			deprecated: !0
		},
		mirrorHistorize: {
			type: "boolean",
			deprecated: !0
		},
		mirrorHistorizeCount: {
			type: "integer",
			deprecated: !0
		},
		mirrorWrite: {
			type: "boolean",
			deprecated: !0
		}
	},
	$comment: "define mirror props already so they are not unknown properties when imported.",
	allOf: [{ $ref: "mirror-configurations.schema.json#/$defs/mirrorproperties" }],
	required: [
		"name",
		"condition",
		"values",
		"timeout",
		"mapping",
		"cloudWrite",
		"cloudRead",
		"enabled",
		"custom"
	]
}, _ = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "connections-measurements.schema.json",
	title: "Capture Edge Local Config V2 - Collector - Connections - Measurements",
	description: "Schema for the measurements of connections in Capture Edge V2",
	type: "object",
	properties: {
		name: {
			type: "string",
			minLength: 1
		},
		downsampleTimespan: {
			type: "string",
			pattern: "^[0-9]*(s|ms)$|\\$(.*)"
		},
		downsampleMethod: {
			type: "string",
			minLength: 1
		},
		downsample: { type: "boolean" },
		endpoints: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				properties: {
					dbId: {
						type: "string",
						minLength: 1
					},
					bucketIdRp: { type: "string" },
					bucketIdDsRp: { type: "string" },
					custom: {
						type: "string",
						isJsonString: !0,
						errorMessage: "Must be a valid JSON object string."
					}
				},
				required: [
					"dbId",
					"bucketIdRp",
					"bucketIdDsRp"
				]
			}
		},
		variables: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: { type: ["integer", "string"] },
					name: {
						type: "string",
						minLength: 1
					},
					parent: { type: "string" },
					type: {
						type: "string",
						minLength: 1
					},
					collectTypeId: {
						type: "integer",
						minimum: 0,
						maximum: 99
					},
					timer: { type: "integer" },
					condition: { type: "string" },
					mapping: {
						type: "string",
						minLength: 1
					},
					downsampleTimespan: {
						type: "string",
						pattern: "^[0-9]*(s|ms)$|\\$(.*)"
					},
					downsampleMethod: {
						type: "string",
						minLength: 1
					},
					downsample: { type: "boolean" },
					cloudWrite: { type: "boolean" },
					cloudRead: { type: "boolean" },
					useAsTag: { type: "boolean" },
					enabled: { type: "boolean" },
					defaultTagValue: { type: "string" },
					custom: {
						type: "string",
						isJsonString: !0,
						errorMessage: "Must be a valid JSON object string."
					},
					preventDeleting: { type: "boolean" },
					preventNameEditing: { type: "boolean" },
					preventMappingEditing: { type: "boolean" },
					tags: {
						type: ["object", "null"],
						additionalProperties: { type: "string" }
					},
					virtualTags: {
						type: ["object", "null"],
						additionalProperties: !0
					},
					mirrorConfigurations: {},
					mirror: {
						type: "boolean",
						deprecated: !0
					},
					mirrorType: {
						type: "integer",
						deprecated: !0
					},
					mirrorHistorize: {
						type: "boolean",
						deprecated: !0
					},
					mirrorHistorizeCount: {
						type: "integer",
						deprecated: !0
					},
					mirrorWrite: {
						type: "boolean",
						deprecated: !0
					},
					mirrorBinding: {
						type: ["string", "null"],
						deprecated: !0
					}
				},
				$comment: "define mirror props already so they are not unknown properties when imported.",
				required: [
					"id",
					"name",
					"parent",
					"type",
					"collectTypeId",
					"timer",
					"condition",
					"mapping",
					"downsampleTimespan",
					"downsampleMethod",
					"downsample",
					"cloudWrite",
					"cloudRead",
					"useAsTag",
					"enabled",
					"defaultTagValue"
				],
				allOf: [{ $ref: "mirror-configurations.schema.json#/$defs/mirrorproperties" }]
			}
		},
		sync: { type: "boolean" },
		analytics: { type: "boolean" },
		analyticsTriggerIds: {
			type: "array",
			items: {
				type: "string",
				minLength: 1
			}
		},
		enabled: { type: "boolean" },
		custom: {
			type: "string",
			isJsonString: !0,
			errorMessage: "Must be a valid JSON object string."
		},
		preventDeleting: { type: "boolean" },
		preventNameEditing: { type: "boolean" },
		syncDest: {
			type: ["array", "null"],
			items: { type: "integer" }
		}
	},
	required: [
		"name",
		"downsampleTimespan",
		"downsampleMethod",
		"downsample",
		"endpoints",
		"variables",
		"sync",
		"analytics",
		"enabled"
	]
}, v = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "connections.schema.json",
	title: "Capture Edge Local Config V2 - Collector - Connections",
	description: "Schema for the connections settings of the collector",
	type: "object",
	properties: {
		type: { type: "integer" },
		address: { type: "string" },
		requestDelay: {
			type: "integer",
			minimum: 0
		},
		readCycleDelay: {
			type: "integer",
			minimum: 0
		},
		byteSwap: { type: "boolean" },
		targetDevice: { type: "string" },
		port: {
			type: "integer",
			minimum: 0,
			maximum: 65535
		},
		cpuType: { type: "integer" },
		rack: { type: "integer" },
		slot: { type: "integer" },
		appName: { type: "string" },
		security: { type: "integer" },
		useIpcTime: { type: "boolean" },
		isTimeManager: { type: "boolean" },
		tags: {
			type: ["array", "null"],
			items: { $ref: "connections-tags.schema.json" }
		},
		conditionTriggers: {
			type: ["array", "null"],
			items: { $ref: "connections-conditiontriggers.schema.json" }
		},
		measurements: {
			type: ["array", "null"],
			items: { $ref: "connections-measurements.schema.json" }
		},
		name: {
			type: "string",
			minLength: 1
		},
		custom: {
			type: "string",
			isJsonString: !0,
			errorMessage: "Must be a valid JSON object string."
		},
		connectionId: { type: "integer" },
		enabled: { type: "boolean" },
		unitId: { type: ["integer", "null"] },
		dbId: { type: ["string", "null"] },
		variableTemplate: { type: ["object", "null"] },
		preventDeleting: { type: "boolean" },
		preventNameEditing: { type: "boolean" }
	},
	required: [
		"type",
		"address",
		"targetDevice",
		"tags",
		"conditionTriggers",
		"measurements"
	],
	allOf: [
		{
			$comment: "min length 1 if use as tag is false",
			if: { properties: { measurements: {
				type: "array",
				minItems: 1,
				items: {
					type: "object",
					properties: { variables: {
						type: "array",
						minItems: 1,
						items: {
							type: "object",
							properties: { useAsTag: { const: !1 } }
						}
					} }
				}
			} } },
			then: {
				properties: { measurements: {
					type: "array",
					items: {
						type: "object",
						properties: { variables: {
							type: "array",
							items: {
								type: "object",
								properties: { mapping: {
									type: "string",
									minLength: 1
								} }
							}
						} }
					}
				} },
				required: ["port"]
			}
		},
		{
			$comment: "0 => ADS  |  8 => ADS (legacy)  |  13 => ADS (binary)",
			$ref: "ads.schema.json"
		},
		{
			$comment: "1 => S7",
			$ref: "s7.schema.json"
		},
		{
			$comment: "3 =>  OPCUA",
			$ref: "opcua.schema.json"
		},
		{
			$comment: "5 =>  CAN",
			$ref: "can.schema.json"
		},
		{
			$comment: "6 => UDP",
			$ref: "udp.schema.json"
		},
		{
			$comment: "7 => MQTT",
			$ref: "mqtt.schema.json"
		},
		{
			$comment: "9 => GPS",
			$ref: "gps.schema.json"
		},
		{
			$comment: "10 => MODBUS",
			$ref: "modbus.schema.json"
		},
		{
			$comment: "11 =>  OPCDA",
			$ref: "opcda.schema.json"
		},
		{
			$comment: "14 => Redis_pubSub  |  15 => Redis_keyValue  |  19 => Redis streams",
			$ref: "redis.schema.json"
		},
		{
			$comment: "16 => Http",
			$ref: "http.schema.json"
		},
		{
			$comment: "17 => Prometheus",
			$ref: "prometheus.schema.json"
		},
		{
			$comment: "18 => Kafka",
			$ref: "kafka.schema.json"
		}
	]
}, y = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "triggers.schema.json",
	title: "Capture Edge Local Config V2 - Collector - triggers",
	description: "Schema for the triggers of the collector",
	type: "object",
	properties: {
		name: {
			type: "string",
			minlength: 1
		},
		id: {
			type: "string",
			pattern: "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$"
		},
		description: { type: "string" },
		subtriggers: {
			type: "array",
			items: { $ref: "subtriggers.schema.json" }
		}
	}
}, b = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "subtriggers.schema.json",
	title: "Capture Edge Local Config V2 - Collector - triggers - subtriggers",
	description: "Schema for the sub-triggers of the triggers",
	type: "object",
	properties: {
		operator: {
			type: "string",
			pattern: "^(>=|<=|==|!=|>|<|and|or)$",
			errorMessage: "Operator must be a valid comparison or logical operator."
		},
		id: {
			type: "string",
			pattern: "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$",
			errorMessage: "ID must be a valid UUID v4."
		},
		name: {
			type: ["string", "null"],
			errorMessage: "Name must be a string."
		},
		connectionId: {
			type: ["integer", "null"],
			errorMessage: "Connection is required."
		},
		measurement: {
			type: ["string", "null"],
			errorMessage: "Measurement is required."
		},
		variable: {
			type: ["string", "null"],
			errorMessage: "Variable is required."
		},
		value: {
			type: [
				"string",
				"integer",
				"number",
				"null"
			],
			errorMessage: "Value is required."
		},
		subtriggers: {
			type: ["array", "null"],
			items: { $ref: "subtriggers.schema.json" },
			errorMessage: "Subtriggers must be a list of valid subtrigger definitions."
		}
	},
	allOf: [{
		if: {
			properties: { subtriggers: {
				type: "array",
				minItems: 1
			} },
			required: ["subtriggers"]
		},
		then: {
			properties: {
				name: { type: ["string", "null"] },
				connectionId: { type: "null" },
				measurement: { type: "null" },
				variable: { type: "null" },
				value: { type: "null" }
			},
			required: ["name"],
			errorMessage: { required: { name: "Name is required when subtriggers are present." } }
		},
		else: {
			properties: {
				name: { type: "null" },
				connectionId: { type: "integer" },
				measurement: {
					type: "string",
					minLength: 1,
					errorMessage: { minLength: "Measurement is required." }
				},
				variable: {
					type: "string",
					minLength: 1,
					errorMessage: { minLength: "Variable is required." }
				},
				value: {
					type: [
						"string",
						"integer",
						"number"
					],
					minLength: 1,
					errorMessage: { minLength: "Value is required." }
				}
			},
			required: [
				"connectionId",
				"measurement",
				"variable",
				"value"
			],
			errorMessage: { required: {
				connectionId: "Connection is required.",
				measurement: "Measurement is required.",
				variable: "Variable is required.",
				value: "Value is required."
			} }
		}
	}],
	errorMessage: { type: "Invalid subtrigger configuration." }
}, x = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "ads.schema.json",
	title: "ADS Connection Validation",
	description: "Conditional validation for ADS connection types (type 0, type 8 [Binary], type 13 [Hex00])",
	allOf: [
		{
			if: { properties: { type: { const: 0 } } },
			then: {
				properties: { address: { pattern: "^(([0-9]{0,3}?).){5}([0-9]{1,3})$|\\$(.*)" } },
				required: ["port", "address"]
			}
		},
		{
			$comment: "8 => ADS Binary",
			if: { properties: { type: { const: 8 } } },
			then: {
				properties: { address: { pattern: "^(([0-9]{0,3}?).){5}([0-9]{1,3})$|\\$(.*)" } },
				required: ["port", "address"]
			}
		},
		{
			$comment: "13 => ADS HEX00",
			if: { properties: { type: { const: 13 } } },
			then: {
				properties: { address: { pattern: "^(([0-9]{0,3}?).){5}([0-9]{1,3})$|\\$(.*)" } },
				required: ["port", "address"]
			}
		}
	]
}, S = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "s7.schema.json",
	title: "S7 Connection Validation",
	description: "Conditional validation for S7 connection type (type 1)",
	if: { properties: { type: { const: 1 } } },
	then: {
		properties: { address: { pattern: "^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|\\$(.*)" } },
		required: [
			"rack",
			"slot",
			"requestDelay",
			"readCycleDelay",
			"address"
		]
	}
}, C = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "opcua.schema.json",
	title: "OPC UA Connection Validation",
	description: "Conditional validation for OPC UA connection type (type 3)",
	if: { properties: { type: { const: 3 } } },
	then: {
		properties: { address: { pattern: "^(.*)@opc.tcp://.*$|^opc.tcp://.*$|\\$(.*)" } },
		required: ["address"]
	}
}, w = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "can.schema.json",
	title: "CAN Connection Validation",
	description: "Conditional validation for CAN connection type (type 5)",
	if: { properties: { type: { const: 5 } } },
	then: {
		properties: { address: { pattern: "^$|([a-zA-Z.0-9-_:;,/+])+$|\\$(.*)" } },
		required: ["cpuType", "address"]
	}
}, T = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "udp.schema.json",
	title: "UDP Connection Validation",
	description: "Conditional validation for UDP connection type (type 6)",
	if: { properties: { type: { const: 6 } } },
	then: {
		properties: { address: { pattern: "^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|\\$(.*)" } },
		required: ["port", "address"]
	}
}, E = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "mqtt.schema.json",
	title: "MQTT Connection Validation",
	description: "Conditional validation for MQTT connection type (type 7)",
	if: { properties: { type: { const: 7 } } },
	then: { required: ["port", "address"] }
}, D = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "gps.schema.json",
	title: "GPS Connection Validation",
	description: "Conditional validation for GPS connection type (type 9)",
	if: { properties: { type: { const: 9 } } },
	then: {
		properties: { address: { pattern: "^$|(.*)$" } },
		required: ["address"]
	}
}, O = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "kafka.schema.json",
	title: "Kafka Connection Validation",
	description: "Conditional validation for Kafka connection type (type 18)",
	if: { properties: { type: { const: 18 } } },
	then: { required: ["port", "address"] }
}, k = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "modbus.schema.json",
	title: "MODBUS Connection Validation",
	description: "Conditional validation for MODBUS connection type (type 10)",
	if: { properties: { type: { const: 10 } } },
	then: {
		properties: {
			address: { pattern: "^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|\\$(.*)" },
			unitId: {
				pattern: "^([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])$",
				default: 1
			}
		},
		required: [
			"byteSwap",
			"port",
			"requestDelay",
			"readCycleDelay",
			"unitId",
			"address"
		]
	}
}, A = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "opcda.schema.json",
	title: "OPC DA Connection Validation",
	description: "Conditional validation for OPC DA connection type (type 11)",
	if: { properties: { type: { const: 11 } } },
	then: { required: ["address"] }
}, j = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "redis.schema.json",
	title: "Redis Connection Validation",
	description: "Conditional validation for Redis connection types (type 14 [pubsub], type 15 [keyvalue], type 19 [streams])",
	allOf: [
		{
			$comment: "14 => Redis_pubSub",
			if: { properties: { type: { const: 14 } } },
			then: {
				properties: { dbId: { default: "0" } },
				required: [
					"port",
					"address",
					"dbId"
				]
			}
		},
		{
			$comment: "15 => Redis_keyValue",
			if: { properties: { type: { const: 15 } } },
			then: {
				properties: { dbId: { default: "0" } },
				required: [
					"port",
					"requestDelay",
					"readCycleDelay",
					"dbId",
					"address"
				]
			}
		},
		{
			$comment: "19 => Redis streams",
			if: { properties: { type: { const: 19 } } },
			then: {
				properties: { dbId: { default: "0" } },
				required: [
					"port",
					"requestDelay",
					"readCycleDelay",
					"dbId",
					"address"
				]
			}
		}
	]
}, M = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "prometheus.schema.json",
	title: "Prometheus Connection Validation",
	description: "Conditional validation for Prometheus connection type (type 17)",
	if: { properties: { type: { const: 17 } } },
	then: {
		required: ["address"],
		description: "To send Prometheus data to Capture, add this to the Prometheus configuration:<br/><br/><code style=\"font-family: monospace;\">remote_write:<br/>&ensp;&ensp;&ensp; - url: \"http://collector:5002/api/ingest/prometheus/receive\"</code>"
	}
}, N = {
	$schema: "https://json-schema.org/draft/2020-12/schema",
	$id: "http.schema.json",
	title: "HTTP Connection Validation",
	description: "Conditional validation for HTTP connection type (type 16)",
	if: { properties: { type: { const: 16 } } },
	then: {
		properties: { readCycleDelay: { default: "30000" } },
		required: [
			"port",
			"readCycleDelay",
			"address"
		]
	}
}, P = /* @__PURE__ */ e({
	adsValidationSchema: () => x,
	analyticsSettingsSchema: () => a,
	canValidationSchema: () => w,
	cloudManagerSettingsSchema: () => o,
	collectorSettingsSchema: () => d,
	companySchema: () => s,
	configurationJsonSchema: () => t,
	connectionsConditionTriggersSchema: () => g,
	connectionsMeasurementsSchema: () => _,
	connectionsSchema: () => v,
	connectionsTagsSchema: () => m,
	edgeBusSettings: () => u,
	edgeCloudBusSettingsSchema: () => c,
	globalSchema: () => f,
	gpsValidationSchema: () => D,
	httpValidationSchema: () => N,
	idSchema: () => n,
	kafkaValidationSchema: () => O,
	localDatabaseConfigSchema: () => r,
	loggerTagSchema: () => l,
	mirrorConfigurationsSchema: () => h,
	modbusValidationSchema: () => k,
	mqttValidationSchema: () => E,
	opcdaValidationSchema: () => A,
	opcuaValidationSchema: () => C,
	prometheusValidationSchema: () => M,
	realTimeSyncDestinationsSchema: () => p,
	redisValidationSchema: () => j,
	s7ValidationSchema: () => S,
	subTriggersSchema: () => b,
	syncSettingsSchema: () => i,
	triggersSchema: () => y,
	udpValidationSchema: () => T
});
//#endregion
export { a as A, f as C, c as D, l as E, r as M, n as N, s as O, t as P, p as S, u as T, v as _, A as a, h as b, D as c, w as d, C as f, y as g, b as h, j as i, i as j, o as k, E as l, x as m, N as n, k as o, S as p, M as r, O as s, P as t, T as u, _ as v, d as w, m as x, g as y };

//# sourceMappingURL=schemas-DgEh9nOm.js.map